import type {CarouselItemData} from '@Components/carousel/carousel.types';
import type {AITextToImageBackendData} from '@Libraries/pmw-stock-media-library';
import type {GenerateAISpeechResponse} from '@Libraries/text-to-speech.library';
import {getUrlForGeneratedAiSpeech} from '@Libraries/text-to-speech.library';
import {GRID_ITEM_TYPE} from '@Components/base-grid/components/grid-item';
import {GeneratedVoiceItem} from '@Panels/ai-voice-panel/components/generated-voice-item';
import {getGeneratedVoiceItemProps} from '@Panels/ai-voice-panel/components/generated-voice-item/generated-voice-item.library';
import {GENERATED_VOICE_GRID_ITEM_WIDTH} from '@Panels/ai-voice-panel/components/generated-voice-list/generated-voice-list.types';
import {getGridItemForAIGeneratedImageV2} from '@Panels/stock-panel/stock-panel.library';
import {AiCarouselContentType} from '@Panels/stock-panel/stock-panel.types';

/**
 * Builders that turn the user's AI-generated content into `CarouselItemData` for the AI carousels. Shared by the
 * main stock panel's aggregated AI row and the dedicated `stock-ai-panel`. (AI video items live in
 * `stock-panel.library.ts` as `getCarouselDataForAiVideoItem` — it carries no JSX.)
 */
export const getAiImageCarouselItem = (aiGeneratedImage: AITextToImageBackendData): CarouselItemData => {
  return {
    gridItemData: getGridItemForAIGeneratedImageV2(aiGeneratedImage),
    width: aiGeneratedImage.imageProps.width,
    height: aiGeneratedImage.imageProps.height,
  };
};

export const getAiVoiceCarouselItem = (voice: GenerateAISpeechResponse, height: number): CarouselItemData => {
  return {
    gridItemData: {
      type: GRID_ITEM_TYPE.CUSTOM,
      id: `ai-voice-${voice.id}`,
      aiContentType: AiCarouselContentType.AUDIO,
      aiId: voice.id,
      children: <GeneratedVoiceItem {...getGeneratedVoiceItemProps(voice, getUrlForGeneratedAiSpeech(voice.filename))} />,
    },
    width: GENERATED_VOICE_GRID_ITEM_WIDTH,
    height,
    hasFixedWidth: true,
  };
};
